
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M27.23 58.7l.02-16.08L15.93 31.2 4.62 42.62V58.7l50.76-.21V28.46H41.32v30.03M54.59 21.61l-6.24-18.3-6.23 18.3"}}),_c('circle',{attrs:{"cx":"15.93","cy":"44.28","r":"3.09","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M15.86 31h25.46M27.14 42.68h13.58M42.18 28.89v-6.86h12.35v6.86"}})])
          )
        }
      }
    